module.exports = __webpack_public_path__ + "img/snowman.12fe2400.png";